// import provinceCode from '@/constant/provinceCode'
import * as Constants from '@/constant'
import Vue from 'vue'
import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'

export const getCodeParam = (route) => {
  return {
    codeParam: {
      moduleCode: Lodash.get(route, 'params.moduleCode')
    }
  }
}

export const newDayjs = (dttm) => {
  // console.debug('dayjs: ' + dayjs)
  return dayjs(new Date(dttm).getTime())
}
export const formatDate = (dttm, format = Constants.DTTM_FORMAT) => {
  // console.debug('dttm: ' + dttm)
  // console.debug('dttm: ', dttm, (new Date(dttm).getTime() === new Date(0).getTime()))
  // debugger
  return (dttm && new Date(dttm).getTime() !== new Date(0).getTime()) ? newDayjs(dttm).format(format) : ''
}

export const formatPH = ($t, path) => {
  $t = Vue.t
  return $t('common.commonVar.prefixPH') + "'" + $t(path) + "'"
}

export const formatValidation = ($t, path) => {
  $t = Vue.t
  return "'" + $t(path) + "'" + $t('common.commonVar.suffixValidation')
}

export const formatI18nValue = ($t, prefix, value) => {
  $t = Vue.t
  const key = prefix + value
  const result = value ? $t(key) : null
  // if (result.startsWith('common.')) {
  //     return '{INVALID VALUE}'
  // } else {
  //     return result
  // }
  return result !== key ? result : '{INVALID VALUE}'
}

export const replaceAll = (str = '', pattern, replacement) => {
  let c = 0
  while (str.indexOf(pattern) >= 0 && c < 20) {
    str = Lodash.replace(str, pattern, replacement)
    c++
  }
  return str
}

export const showMessage = (_this, message, type) => {
  _this.$Notice[type || 'success']({ desc: message })
}

export const label = (value) => {
  return value + ': '
}

export const labelWidth = (isMobile, width = 140) => {
  return isMobile ? undefined : width
}

export const labelPosition = (isMobile) => {
  return isMobile ? 'top' : 'right'
}

export const setValueTimeout = (target, fieldPath, value, time = 0) => {
  setTimeout(() => {
    Lodash.set(target, fieldPath, value)
  }, time)
}

export const nextTickSimple = (_this, fieldPath, value) => {
  Lodash.set(_this, fieldPath, !value)
  _this.$nextTick(() => {
    Lodash.set(_this, fieldPath, value)
  })
}

export const nextTick = (_this, fieldPath, value, time = 0) => {
  if (time) {
    setTimeout(() => {
      nextTickSimple(_this, fieldPath, value)
    }, time)
  } else {
    nextTickSimple(_this, fieldPath, value)
  }
}

export const numFormat = (value) => {
  if (!value) return '0'
  const intPart = Number(value).toFixed(0) // 获取整数部分
  return intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
}

// 根据menuKey从resourceList中获取url
export const getUrlByMenuKey = (resourceList, menuKey) => {
  let url = ''
  resourceList.forEach(res => {
    let menu = res.children.find(item => item.menuKey === menuKey)
    if (menu) {
      url = menu.url
    }
  })
  return url
}

// 根据menuKey从resourceList中获取name
export const getNameByMenuKey = (resourceList, menuKey) => {
  let name = ''
  resourceList.forEach(res => {
    let menu = res.children.find(item => item.menuKey === menuKey)
    if (menu) {
      name = menu.name
    }
  })
  return name
}

// // 通过格子的数据获取到格子的边界点
// export const getRectangleByStepAndGridCode = (gridCode, lngStep, latStep) => {
//   const gridCodeArr = gridCode.split('::')
//   const lng = Number((gridCodeArr[0] * lngStep).toFixed(6))
//   const lat = Number((gridCodeArr[1] * latStep).toFixed(6))
//   const southWest = [lng, lat]
//   const northEast = [lng + lngStep, lat + latStep]
//   return [southWest, northEast]
// }

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const isValidDateValue = (date) => {
  // debugger
  if (!date || new Date(date).getTime() <= 0) {
    return false
  }

  return true
}
// export const formatDate = (date) => {
//   if (!isValidDateValue(date)) return ''
//   date = new Date(date)
//   //
//   const year = date.getFullYear()
//   const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
//   const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
//   const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
//   const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
//   const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
//
//   return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`
// }
export const formatDateToAll = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let milliseconds = date.getMilliseconds()
  if (milliseconds < 100) {
    milliseconds = '00' + milliseconds
  } else if (milliseconds < 10) {
    milliseconds = '0' + milliseconds
  }
  // const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return `${year}-${month}-${day} ${hour}:${minute}:${seconds}.${milliseconds}`
}
export const formatDateToMinute = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

  return `${year}-${month}-${day} ${hour}:${minute}`
}
export const formatDateToHourStr = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()

  return `${year}-${month}-${day} ${hour}`
}
export const formatDateToDay = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  return `${year}-${month}-${day}`
}
export const formatDateToMonth = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)

  return `${year}-${month}`
}
export const formatDateToMonthInt = (date) => {
  if (!isValidDateValue(date)) return 0
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)

  return parseInt(`${year}`) * 100 + parseInt(`${month}`)
}
export const formatIntMonth = (date) => {
  if (!date) return ''
  // if (!isValidDateValue(date)) return 0
  // date = new Date(date)
  //
  date = date + ''
  if (date.length !== 6) return ''
  const year = date.substring(0, 4)
  const month = date.substring(4)

  // return parseInt(`${year}`) * 100 + parseInt(`${month}`)
  return `${year}-${month}`
}
export const formatDateToDayNum = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  return `${year}${month}${day}`
}
export const formatDateToMonthNum = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const year = date.getFullYear()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  // const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  return `${year}${month}`
}
export const formatDateToNoYear = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

  return `${month}-${day} ${hour}:${minute}`
}
export const formatDateToHHmmss = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return `${hour}:${minute}:${seconds}`
}
export const formatDateToHour = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

  return `${hour}:${minute}`
}
export const formatDateToOnlyMinute = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

  return `${minute}`
}
export const formatDateToOnlyHour = (date) => {
  if (!isValidDateValue(date)) return ''
  date = new Date(date)
  //
  const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()

  return `${hour}`
}

export const parseDate = (value) => {
  return isValidDateValue(value) ? new Date(value) : null
}
/**
 * 根据当前日期获取上一个月
 * return “2018-01”
 */
export const getPreMonth = () => {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  if (month === 0) {
    year = year - 1
    month = 12
  }
  month = month < 10 ? '0' + month : month
  return `${year}-${month}`
}
export const formatIntDateToStr = (dateInt) => {
  if (dateInt && dateInt > 0) {
    let dateStr = dateInt.toString()
    return dateStr.slice(0, 4) + '/' + dateStr.slice(4, 6) + '/' + dateStr.slice(6) + ' 00:00:00'
  } else {
    return ''
  }
}

export const getDateNoTime = (value) => {
  if (!value) {
    return null
  }
  let date = new Date(value)
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
  return date
}

export const getMonthFirstDay = (value) => {
  if (!value) {
    return null
  }
  let date = getDateNoTime(value)
  date.setDate(1)
  return date
}

export const getMonthLastDay = (value) => {
  if (!value) {
    return null
  }
  let date = getMonthFirstDay(value)
  date.setMonth(date.getMonth() + 1)
  date.setDate(date.getDate() - 1)
  return date
}

export const renderHeader = (h, params) => {
  return h('Tooltip', {
    props: {
      content: params.column.title,
      transfer: true,
      placement: 'top'
    }
  }, params.column.title)
}

export const formatTreeNumber = (seqLevel1, seqLevel2, seqLevel3) => {
  if (seqLevel1 && seqLevel2 && seqLevel3) {
    return seqLevel1 + '.' + seqLevel2 + '.' + seqLevel3
  } else if (seqLevel1 && seqLevel2) {
    return seqLevel1 + '.' + seqLevel2
  } else if (seqLevel1) {
    return seqLevel1
  } else {
    return 'incorrect number.'
  }
}

export const formatThousandthNumberComputed = (value) => {
  // debugger
  // if (!isNaN(value)) {
  return value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  // }
}

export const parserThousandthNumberComputed = (value) => {
  // debugger
  // if (!isNaN(value)) {
  return value => `${value}`.replace(/$s?|(,*)/g, '')
  // }
}

export const formatThousandthNumber = (value, fractionDigits = 2) => {
  // debugger
  if (value) {
    return parseFloat(value).toFixed(fractionDigits).replace(/\d+/, function (n) { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
        return $1 + ','
      })
    })
    // return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export const formatThousandthNumberAllowZero = (value, fractionDigits = 2) => {
  // debugger
  if (value || value === 0) {
    return parseFloat(value).toFixed(fractionDigits).replace(/\d+/, function (n) { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
        return $1 + ','
      })
    })
    // return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export const parserThousandthNumber = (value) => {
  // debugger
  if (value) {
    return parseFloat(value).toFixed(2).replace(/$s?|(,*)/g, '')
    // return `${value}`.replace(/$s?|(,*)/g, '')
  }
}

export const covertZeroToNull = (value) => {
  return value || null
}

export const covertNullToZero = (value) => {
  return value || 0
}

export const isActiveItem = (item) => {
  return item.status === Constants.DEFAULT_STATUS
}

export const isUsedItem = (item) => {
  return item.indUsed === Constants.IND_USED.YES
}

export const findFirstItem = (list) => {
  // let item
  // return (item = this.sysCompanyDDList.find(item => (item.compId === compId))) ? item.compName : ''
  return Array.isArray(list) ? list.find(item => isActiveItem(item)) : null
}

export const findFirstItemValue = (list) => {
  // debugger
  let item = findFirstItem(list)
  return item ? item.value : null
}

export const findItemByValue = (list, value) => {
  // debugger
  return Array.isArray(list) ? list.find(item => (item.value === value)) : null
}

export const findItemDescrByValue = (list, value) => {
  // debugger
  let item = findItemByValue(list, value)
  // return item ? item.descr : value
  return item ? item.descr : ''
}

export const setDDDefaultValue = (thisObj, valueField, list, defaultValue) => {
  // debugger
  // console.log('setDDDefaultValue', thisObj, valueField, list, defaultValue)
  // if (valueField === 'ctrAcctId') {
  //   debugger
  // }
  // const value = findFirstItemValue(list)
  // 如果下拉列表没有任何值, 设置该下拉列表的值为null
  if (!Array.isArray(list) || !list.length) {
    thisObj[valueField] = null
    return
  }
  // 下拉列表有选项的情况下, 如果该下拉列表还没有设置值, 设置该下拉列表的值为第一个可用选项的值(或默认值)
  if (!thisObj[valueField]) {
    // 如果默认值在列表中存在, 设置下拉列表的值为默认值
    if (defaultValue && findItemByValue(list, defaultValue)) {
      thisObj[valueField] = defaultValue
      // if (thisObj[valueField] !== defaultValue) thisObj[valueField] = defaultValue
    } else {
      // 如果没有默认值, 或者默认值在列表中不存在, 设置下拉列表的值为第一个可用选项
      thisObj[valueField] = findFirstItemValue(list)
      // console.log('thisObj[valueField]', this, valueField, thisObj[valueField])
      // let value = findFirstItemValue(list)
      // if (thisObj[valueField] !== value) thisObj[valueField] = findFirstItemValue(list)
    }

    // return
  }
  // return
}

export const toListWapper = (list, {valueField, descrField, joinSeparator}) => {
  // debugger
  console.log(typeof descrField)
  return Array.isArray(list) ? list.map(item => {
    item.value = item[valueField]
    if (typeof descrField === 'string') {
      item.descr = item[descrField]
    } else if (Array.isArray(descrField)) {
      item.descr = []
      descrField.forEach(field => {
        item.descr.push(item[field])
      })
      item.descr = item.descr.join(joinSeparator || '')
    }
    return item
  }) : []
}

export const getDefaultDDStore = () => {
  return { list: [], map: {} }
}

export const getDDStore = (resultList) => {
  const DDStore = {}
  const map = {}
  DDStore.list = Lodash.map(resultList, function (item) {
    const rs = item
    map[rs.value] = rs
    return rs
  })
  DDStore.map = map
  return DDStore
}

export const copyDDStore = (sourceDDStore, targetDDStore) => {
  targetDDStore.list = sourceDDStore.list
  targetDDStore.map = sourceDDStore.map
}

export const isSummaryRow = (row) => {
  // return false
  return row && row.recordType && Lodash.startsWith(row.recordType, 'SUM_')
}

export const getDefaultListPagging = () => {
  return {
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  }
}

export const resetListPagging = (listPagging, res) => {
  listPagging.currentPage = res.currentPage
  listPagging.pageSize = res.pageSize
  if ((res.total !== 0 && res.totalPage !== 0) || Lodash.size(res.data) === 0) {
    listPagging.total = res.total
    listPagging.totalPage = res.totalPage
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js